import { useMutation, useQueryClient } from '@tanstack/react-query';

import { archiveProductDraft } from '../api/archiveProductDraft';

export const useArchiveProductDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, archived }: { id: number; archived: boolean }) =>
      archiveProductDraft(id, archived),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products-drafts'] });
    }
  });
};
